export { default } from "./clickableArea";
